/* eslint-disable max-len */
/**
 * Created by calhosh on 4/14/2017.
 */
import * as english from './en-us.js';
import {engagementProfileResources, subServiceLineNames} from '../util/uiconstants';
import {ResourceManager} from '@ey/voltron-core';

export const manager = new ResourceManager('en-us', english)
	.addResource('ar', () => import('./ar'))
	.addResource('fr-ca', () => import('./fr-ca'))
	.addResource('ja-jp', () => import('./ja-jp'))
	.addResource('es', () => import('./es'))
	.addResource('es-mx', () => import('./es'))
	.addResource('he', () => import('./he'))
	.addResource('ko', () => import('./ko'))
	.addResource('pt-br', () => import('./pt-br'))
	.addResource('ru', () => import('./ru'))
	.addResource('zh-sp', () => import('./zh-sp'))
	.addResource('zh-tr', () => import('./zh-tr'))

	.addResource('ar.Faas', () => import('./SubServiceLine/ar.faas'))
	.addResource('en-us.Faas', () => import('./SubServiceLine/en-us.faas'))
	.addResource('fr-ca.Faas', () => import('./SubServiceLine/fr-ca.faas'))
	.addResource('es.Faas', () => import('./SubServiceLine/es.faas'))
	.addResource('he.Faas', () => import('./SubServiceLine/he.faas'))
	.addResource('ja-jp.Faas', () => import('./SubServiceLine/ja-jp.faas'))
	.addResource('ko.Faas', () => import('./SubServiceLine/ko.faas'))
	.addResource('ru.Faas', () => import('./SubServiceLine/ru.faas'))
	.addResource('pt-br.Faas', () => import('./SubServiceLine/pt-br.faas'))
	.addResource('zh-sp.Faas', () => import('./SubServiceLine/zh-sp.faas'))
	.addResource('zh-tr.Faas', () => import('./SubServiceLine/zh-tr.faas'))

	.addResource('ar.SustainableAuditMethodology', () => import('./SubServiceLine/ar.audit.sam'))
	.addResource('en-us.SustainableAuditMethodology', () => import('./SubServiceLine/en-us.audit.sam'))
	.addResource('es.SustainableAuditMethodology', () => import('./SubServiceLine/es.audit.sam'))
	.addResource('fr-ca.SustainableAuditMethodology', () => import('./SubServiceLine/fr-ca.audit.sam'))
	.addResource('ja-jp.SustainableAuditMethodology', () => import('./SubServiceLine/ja-jp.audit.sam'))
	.addResource('ko.SustainableAuditMethodology', () => import('./SubServiceLine/ko.audit.sam'))
	.addResource('pt-br.SustainableAuditMethodology', () => import('./SubServiceLine/pt-br.audit.sam'))
	.addResource('ru.SustainableAuditMethodology', () => import('./SubServiceLine/ru.audit.sam'))
	.addResource('zh-sp.SustainableAuditMethodology', () => import('./SubServiceLine/zh-sp.audit.sam'))
	.addResource('zh-tr.SustainableAuditMethodology', () => import('./SubServiceLine/zh-tr.audit.sam'))
	.addResource('he.SustainableAuditMethodology', () => import('./SubServiceLine/he.audit.sam'))

	.addResource('ar.PCAOB', () => import('./SubServiceLine/ar.audit.PCAOB'))
	.addResource('en-us.PCAOB', () => import('./SubServiceLine/en-us.audit.PCAOB'))
	.addResource('es.PCAOB', () => import('./SubServiceLine/es.audit.PCAOB'))
	.addResource('fr-ca.PCAOB', () => import('./SubServiceLine/fr-ca.audit.PCAOB'))
	.addResource('he.PCAOB', () => import('./SubServiceLine/he.audit.PCAOB'))
	.addResource('ja-jp.PCAOB', () => import('./SubServiceLine/ja-jp.audit.PCAOB'))
	.addResource('ko.PCAOB', () => import('./SubServiceLine/ko.audit.PCAOB'))
	.addResource('pt-br.PCAOB', () => import('./SubServiceLine/pt-br.audit.PCAOB'))
	.addResource('ru.PCAOB', () => import('./SubServiceLine/ru.audit.PCAOB'))
	.addResource('zh-sp.PCAOB', () => import('./SubServiceLine/zh-sp.audit.PCAOB'))
	.addResource('zh-tr.PCAOB', () => import('./SubServiceLine/zh-tr.audit.PCAOB'))
	;

export async function preloadResources(locale, subServiceLine, languageResource) {
	let resourceIds = [locale];
	let resourceFileName = languageResource in engagementProfileResources
		? engagementProfileResources[languageResource]
		: subServiceLineNames[subServiceLine];

	if (resourceFileName) {
		let defaultSubServiceLineId = `en-us.${resourceFileName}`;
		let subServiceLineId = `${locale}.${resourceFileName}`;
		resourceIds.push(defaultSubServiceLineId, subServiceLineId);
	}

	for (let id of resourceIds) {
		if (!manager.resources.has(id) && manager.resourceFactories.has(id)) {
			try {
				const content = await manager.resourceFactories.get(id)();
				manager.addResourceContent(id, content);
			} catch (e) {
				console.warn(`Failed to preload localization resource "${id}".`, e);
			}
		}
	}
}

export default function getResources(locale, subServiceLine, languageResource) {
	let resourceIds = [locale];
	let resourceFileName = languageResource in engagementProfileResources
		? engagementProfileResources[languageResource]
		: subServiceLineNames[subServiceLine];

	if (resourceFileName) {
		let defaultSubServiceLineId = `en-us.${resourceFileName}`;
		let subServiceLineId = `${locale}.${resourceFileName}`;
		resourceIds.push(defaultSubServiceLineId, subServiceLineId);
	}

	let resourceContent = manager.resolve(...resourceIds);
	return resourceContent;
}
